import { useRouter, useRoute } from 'vue-router'

/**
 * Chemins d’application (site monolingue, pas de préfixe de langue dans l’URL).
 */
export function useLocalizedRouter() {
  const router = useRouter()
  const route = useRoute()

  const localizedPath = (path: string): string => {
    const cleanPath = path.startsWith('/') ? path : `/${path}`
    return cleanPath === '' ? '/' : cleanPath
  }

  const pushLocalized = (path: string) => {
    return router.push(localizedPath(path))
  }

  /** Chemin courant (ex. pour liens « même page »). */
  const currentPath = () => route.path || '/'

  return {
    localizedPath,
    pushLocalized,
    currentPath
  }
}
